import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../context/StoreContext.jsx';
import { BRAND } from '../config/brand.js';

export default function Footer() {
  const { settings } = useStore();
  const c = settings.contact || {};
  return (
    <footer className="footer">
      <div className="footer__grid">
        <div>
          <h4>About</h4>
          <Link to="/about">Who We Are</Link>
          <Link to="/korean-wear">Korean Wear (Coming Soon)</Link>
        </div>
        <div>
          <h4>Customer Service</h4>
          <Link to="/contact">Contact Us</Link>
          {c.email && <a href={`mailto:${c.email}`}>{c.email}</a>}
          {c.phone && <a href={`tel:${c.phone.replace(/\s/g, '')}`}>{c.phone}</a>}
          {c.address && <span>{c.address}</span>}
        </div>
        <div>
          <h4>Policies</h4>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms and Conditions</Link>
        </div>
        <div>
          <h4>Follow</h4>
          {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer">Instagram</a>}
          {c.facebook && <a href={c.facebook} target="_blank" rel="noreferrer">Facebook</a>}
          {c.whatsapp && <a href={`https://wa.me/${c.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer">WhatsApp</a>}
        </div>
      </div>
      <p className="footer__copy">&copy; {new Date().getFullYear()} {BRAND}. All rights reserved.</p>
    </footer>
  );
}
